export const badgeConfig: { [key: string]: string } = {
  "Live with scheduled end date": "rgba(29, 209, 156, 0.1)",
  draft: "#e7e9eb",
  closed: "rgba(49, 160, 178, 0.1)",
  published: "rgba(29, 209, 156, 0.1)",
  matched: "rgba(93, 194, 245, 0.3)",
  processed: "rgba(29, 209, 156, 0.1)",
  expired: "rgba(49, 160, 178, 0.1)",
};

export const odpLimtsBadge: { [key: string]: string } = {
  defaultCompanyLimit: "rgba(49, 160, 178, 0.1)",
};

export const reconciledODPBadge: { [key: string]: string } = {
  defaultCompanyLimit: "rgba(49, 160, 178, 0.1)",
};

export const xeroInvoice: { [key: string]: string } = {
  link: "#052035",
};

export const payslipBadgeConfig: { [key: string]: string } = {
  pending_upload: "rgba(239, 249, 254, 1)",
  uploaded: "rgba(239, 249, 254, 1)",
  processing: "rgba(239, 249, 254, 1)",
  processed: "rgba(239, 249, 254, 1)",
  matching: "rgba(239, 249, 254, 1)",
  matched: "rgba(239, 249, 254, 1)",
  partially_matched: "rgba(255, 212, 59, 0.1)",
  failed: "rgba(240, 62, 62, 0.1)",
  processing_timeout: "rgba(240, 62, 62, 0.1)",
  matching_timeout: "rgba(240, 62, 62, 0.1)",
  matches_needed: "rgba(255, 212, 59, 0.1)",
  cancelled: "rgba(6, 33, 51, 0.2)",
  finalizing: "rgba(239, 249, 254, 1)",
  finalized: "rgba(29, 209, 156, 0.1)",
  finalized_with_errors: "rgba(255, 212, 59, 0.1)",
  partially_imported: "rgba(240, 62, 62, 0.1)",
};

export const payslipBadgeLabel: { [key: string]: string } = {
  pending_upload: "Uploading",
  uploaded: "Uploading",
  processing: "Uploading",
  processed: "Uploading",
  matching: "Uploading",
  matched: "Ready to Send",
  partially_matched: "Unassigned",
  failed: "Failed",
  processing_timeout: "Failed",
  matching_timeout: "Failed",
  matches_needed: "Unassigned",
  cancelled: "Cancelled",
  finalizing: "Sending",
  finalized: "Sent",
  finalized_with_errors: "Sent",
  partially_imported: "Failed",
};

export const employeeImportJobConfig: { [key: string]: string } = {
  created: "rgba(255, 212, 59, 0.3)",
  processing: "rgba(255, 212, 59, 0.3)",
  processed: "rgba(29, 209, 156, 0.1)",
  analysing: "rgba(255, 212, 59, 0.3)",
  analysed: "rgba(29, 209, 156, 0.1)",
  failed: "rgba(49, 160, 178, 0.1)",
  cancelled: "rgba(49, 160, 178, 0.1)",
  finalizing: "rgba(255, 212, 59, 0.3)",
  completed: "rgba(29, 209, 156, 0.1)",
  completed_with_errors: "rgba(49, 160, 178, 0.1)",
};

export const classNames = (...classes: string[]): string =>
  classes.filter(Boolean).join(" ");

export const globalStyle = {
  inputLabel: {
    flexGrow: 0,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "var(--grey-grey-80)",
  },
};
